import classNames from "classnames";
import { ComponentProps, HTMLProps } from "react";

type IconProps = {
  className?: string;
} & ComponentProps<"svg">;

const Icon = () => {};

Icon.Menu = function Menu(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="17"
      fill="none"
      viewBox="0 0 18 14"
      {...props}
    >
      <rect
        width="17.067"
        height="2.133"
        x="0.467"
        y="0.6"
        fill="currentColor"
        rx="1.067"
      ></rect>
      <rect
        width="12.8"
        height="2.133"
        x="4.733"
        y="5.933"
        fill="currentColor"
        rx="1.067"
      ></rect>
      <rect
        width="17.067"
        height="2.133"
        x="0.467"
        y="11.267"
        fill="currentColor"
        rx="1.067"
      ></rect>
    </svg>
  );
};

Icon.Play = function Play(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="15"
      fill="none"
      viewBox="0 0 13 15"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1.886 14.5c-.23 0-.456-.062-.656-.178-.45-.258-.73-.76-.73-1.306V1.984c0-.547.28-1.048.73-1.306A1.303 1.303 0 012.57.695l9.296 5.644c.194.123.353.294.464.497a1.385 1.385 0 01-.464 1.824L2.57 14.305a1.317 1.317 0 01-.684.195z"
      ></path>
    </svg>
  );
};

Icon.Pause = function Pause({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        fillRule="evenodd"
        d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

Icon.Stop = function Stop({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <rect x="3.5" y="3.5" width="17" height="17" rx="1.5" />
    </svg>
  );
};

Icon.Settings = function Settings({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={classNames("size-6", className)}
      {...rest}
    >
      <line x1="4" y1="6" x2="20" y2="6" />
      <circle cx="9" cy="6" r="2" fill="currentColor" stroke="none" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <circle cx="16" cy="12" r="2" fill="currentColor" stroke="none" />
      <line x1="4" y1="18" x2="20" y2="18" />
      <circle cx="11" cy="18" r="2" fill="currentColor" stroke="none" />
    </svg>
  );
};

Icon.Headphones = function Headphones({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path d="M3 13.5V12a9 9 0 0 1 18 0v1.5" />
      <rect x="2.5" y="13.5" width="4.5" height="7" rx="1.5" fill="currentColor" stroke="none" />
      <rect x="17" y="13.5" width="4.5" height="7" rx="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
};

Icon.PlayInverted = function PlayInverted({
  bgClassName,
  ...props
}: {
  bgClassName?: HTMLProps<HTMLElement>["className"];
} & IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 32 32"
      {...props}
    >
      <rect
        width={32}
        height={32}
        className={bgClassName}
        fill="#4591B8"
        rx={4}
      />
      <path
        fill="#fff"
        d="M10.733 24c-.288 0-.57-.07-.82-.203A1.69 1.69 0 0 1 9 22.304V9.696c0-.625.35-1.197.912-1.493a1.749 1.749 0 0 1 1.677.02l11.62 6.45c.242.14.442.337.58.568.138.232.211.493.211.758s-.073.526-.211.758a1.623 1.623 0 0 1-.58.568l-11.622 6.452a1.763 1.763 0 0 1-.854.223Z"
      />
    </svg>
  );
};

Icon.PauseInverted = function PauseInverted({
  bgClassName,
  ...props
}: {
  bgClassName?: HTMLProps<HTMLElement>["className"];
} & IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 32 32"
      {...props}
    >
      <rect
        width={32}
        height={32}
        className={bgClassName}
        fill="#4591B8"
        rx={4}
      />
      <rect width={6} height={16} x={8} y={8} fill="#fff" rx={2} />
      <rect width={6} height={16} x={18} y={8} fill="#fff" rx={2} />
    </svg>
  );
};

Icon.Ellipsis = function Ellipsis({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <circle cx="5" cy="12" r="2" />
      <circle cx="12" cy="12" r="2" />
      <circle cx="19" cy="12" r="2" />
    </svg>
  );
};

Icon.Share = function share({ className, ...rest }: IconProps) {
  return (
    <svg
      width={25}
      height={31}
      viewBox="0 0 25 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        d="M8.7613 6.93177L10.8696 5.02763V20.1258C10.8696 20.9391 11.5996 21.5985 12.5 21.5985C13.4004 21.5985 14.1304 20.9391 14.1304 20.1258V5.02773L16.2385 6.93177C16.5568 7.21933 16.974 7.36316 17.3913 7.36316C17.8086 7.36316 18.2259 7.21943 18.5441 6.93177C19.1809 6.35665 19.1809 5.42426 18.5441 4.84914L13.6532 0.431389C13.6149 0.396928 13.5748 0.364334 13.5332 0.333506C13.5151 0.320154 13.4961 0.308569 13.4777 0.296101C13.4536 0.279705 13.43 0.263015 13.4049 0.247798C13.3824 0.234151 13.359 0.22237 13.3359 0.209902C13.3134 0.19763 13.2913 0.184867 13.268 0.173675C13.2445 0.162286 13.2203 0.152665 13.1962 0.142454C13.172 0.132048 13.1483 0.121248 13.1234 0.111921C13.1001 0.103184 13.0764 0.0962132 13.0528 0.0885554C13.0263 0.0799158 13.0001 0.0706872 12.9728 0.063324C12.9493 0.0569425 12.9255 0.05223 12.902 0.0468303C12.8741 0.0404488 12.8465 0.0333801 12.8181 0.0283731C12.791 0.0235624 12.7635 0.0207153 12.7361 0.0170827C12.7109 0.0138429 12.6861 0.00952314 12.6605 0.00726508C12.6103 0.00284712 12.56 0.000687237 12.5096 0.000392707C12.5063 0.000392707 12.5032 0 12.4999 0C12.4967 0 12.4935 0.000392707 12.4903 0.000392707C12.4399 0.00058906 12.3895 0.00284712 12.3391 0.00726508C12.3141 0.00952314 12.2899 0.0137447 12.2652 0.0168864C12.2372 0.0205189 12.2091 0.0234642 12.1814 0.0284712C12.1538 0.0333801 12.1271 0.0402525 12.1 0.0464376C12.0754 0.0520337 12.0509 0.0568443 12.0265 0.0634222C12.0003 0.0705891 11.9748 0.0795231 11.9491 0.0878682C11.9247 0.0958205 11.9 0.103086 11.8759 0.112118C11.852 0.121052 11.8291 0.131557 11.8059 0.141473C11.7809 0.152076 11.7557 0.162188 11.7311 0.173969C11.7089 0.18467 11.688 0.196844 11.6664 0.208527C11.6422 0.221487 11.6178 0.233857 11.5942 0.248093C11.5707 0.262328 11.5486 0.278233 11.5259 0.29345C11.5059 0.3069 11.4855 0.319369 11.4662 0.333801C11.4265 0.363156 11.3886 0.394278 11.3522 0.426774C11.3504 0.428345 11.3486 0.429621 11.3467 0.431192L6.45522 4.84914C5.81848 5.42426 5.81848 6.35665 6.45522 6.93177C7.09228 7.50689 8.12467 7.50669 8.7613 6.93177Z"
        fill="currentColor"
      />
      <path
        d="M23.3696 9.81763H19.0217C18.1213 9.81763 17.3913 10.477 17.3913 11.2903C17.3913 12.1036 18.1213 12.7629 19.0217 12.7629H21.7391V27.4894H3.26087V12.7629H5.97826C6.8787 12.7629 7.6087 12.1036 7.6087 11.2903C7.6087 10.477 6.8787 9.81763 5.97826 9.81763H1.63043C0.73 9.81763 0 10.477 0 11.2903V28.9621C0 29.7754 0.73 30.4347 1.63043 30.4347H23.3696C24.27 30.4347 25 29.7754 25 28.9621V11.2903C25 10.477 24.27 9.81763 23.3696 9.81763Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.Image = function ImageIcon({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        d="m39.5834 27.0834c-.5525 0-1.0824.2195-1.4731.6102s-.6102.9206-.6102 1.4731v.7917l-3.0834-3.0834c-1.0887-1.0801-2.5601-1.6862-4.0937-1.6862s-3.0051.6061-4.0938 1.6862l-1.4583 1.4584-5.1667-5.1667c-1.1039-1.0508-2.5696-1.6369-4.0937-1.6369s-2.9898.5861-4.0938 1.6369l-3.08329 3.0833v-11.6666c0-.5526.2195-1.0825.6102-1.4732s.9206-.6102 1.47309-.6102h14.5834c.5525 0 1.0824-.2195 1.4731-.6102s.6102-.9206.6102-1.4731c0-.55254-.2195-1.08244-.6102-1.47314s-.9206-.6102-1.4731-.6102h-14.5834c-1.65756 0-3.24727.65848-4.41937 1.83054-1.1721 1.1721-1.83058 2.7619-1.83058 4.4195v25c0 1.6576.65848 3.2473 1.83058 4.4194s2.76181 1.8306 4.41937 1.8306h25c1.6576 0 3.2474-.6585 4.4195-1.8306s1.8305-2.7618 1.8305-4.4194v-10.4167c0-.5525-.2194-1.0824-.6101-1.4731s-.9207-.6102-1.4732-.6102zm-29.1667 14.5833c-.55249 0-1.08239-.2195-1.47309-.6102s-.6102-.9206-.6102-1.4731v-7.4375l6.04169-6.0417c.306-.2917.7126-.4544 1.1354-.4544s.8293.1627 1.1354.4544l6.6042 6.6042 8.9583 8.9583zm27.0834-2.0833c-.003.3988-.1345.786-.375 1.1041l-9.3959-9.4375 1.4584-1.4583c.1493-.1524.3276-.2736.5244-.3562.1967-.0827.408-.1253.6214-.1253s.4247.0426.6215.1253c.1967.0826.375.2038.5243.3562l6.0209 6.0625zm9.8125-30.64587-6.25-6.25c-.1982-.18967-.4318-.33835-.6875-.4375-.5072-.20837-1.0761-.20837-1.5834 0-.2557.09915-.4893.24783-.6875.4375l-6.25 6.25c-.1942.19425-.3483.42485-.4534.67865-.1051.25379-.1592.52582-.1592.80052 0 .5548.2203 1.0869.6126 1.4792s.9244.6127 1.4792.6127 1.0869-.2204 1.4792-.6127l2.6875-2.70837v11.64587c0 .5525.2195 1.0824.6102 1.4731s.9206.6102 1.4731.6102 1.0825-.2195 1.4732-.6102.6101-.9206.6101-1.4731v-11.64587l2.6875 2.70837c.1937.1952.4241.3502.678.456s.5262.1602.8012.1602.5473-.0544.8012-.1602.4843-.2608.678-.456c.1952-.1937.3502-.4241.456-.678s.1602-.5262.1602-.8012-.0544-.54733-.1602-.80121c-.1058-.25387-.2608-.48429-.456-.67796z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.Quote = function quote(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="57"
      fill="none"
      viewBox="0 0 67 57"
      {...props}
    >
      <path d="M3.345 56.246.562 50.24q8.496-3.515 12.011-7.763 3.516-4.248 3.516-9.229 0-3.076-1.172-5.127a16.4 16.4 0 0 0-3.223-3.662 105 105 0 0 1-3.808-3.076A11.2 11.2 0 0 1 4.81 17.72q-1.32-2.198-1.319-5.713 0-4.98 3.809-8.496Q10.962-.004 16.82-.004q3.516 0 7.031 1.904 3.37 1.905 5.713 6.006 2.198 4.248 2.198 11.133 0 7.91-3.077 14.941-3.222 7.032-9.521 12.745t-15.82 9.521m34.717 0-2.784-6.006q8.496-3.515 12.012-7.763t3.516-9.229q0-3.076-1.172-5.127a16.4 16.4 0 0 0-3.223-3.662 105 105 0 0 1-3.809-3.076 11.2 11.2 0 0 1-3.076-3.662q-1.318-2.198-1.318-5.713 0-4.98 3.809-8.496 3.662-3.516 9.521-3.516 3.516 0 7.031 1.904 3.369 1.905 5.713 6.006 2.198 4.248 2.198 11.133 0 7.91-3.077 14.941-3.222 7.032-9.521 12.745t-15.82 9.521"></path>
    </svg>
  );
};

Icon.Logo = function logo(props: IconProps) {
  return (
    <svg
      width="70"
      height="30"
      viewBox="0 0 70 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9628 28.9754L25.1501 8.7804H32.0041L31.5236 11.9008H38.0445C38.5038 11.9008 38.8435 12.3029 38.7707 12.7602L38.0902 17.0463C38.0284 17.434 37.6893 17.7257 37.3001 17.7257H30.598L28.7828 29.1891C28.7094 29.6514 28.3046 29.9999 27.8404 29.9999H22.829C22.282 29.9999 21.8767 29.5209 21.9628 28.9754Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.5003 1.03427L65.0369 29.1732C64.9606 29.6518 64.5529 30 64.0678 30H58.0098C57.6088 30 57.2422 29.7598 57.0784 29.3898L56.9511 29.1024L47.3813 7.47914C47.3005 7.29859 47.2068 7.12257 47.0847 6.96905C46.6433 6.41339 45.9659 6.08376 45.2298 6.08376H10.5388L9.63815 11.7481H16.7937C17.2579 11.7481 17.6005 12.1535 17.5276 12.6147L16.8396 16.9365C16.7784 17.329 16.4348 17.6226 16.0439 17.6226H8.70463L7.74291 23.7064H18.8073C19.2693 23.7064 19.6118 24.1113 19.539 24.5731L18.7882 29.3144C18.7265 29.7064 18.3828 30 17.9896 30H0.970515C0.36607 30 -0.0808633 29.4696 0.0123132 28.865L4.42738 0.897601C4.50752 0.385837 4.95612 0 5.47035 0H49.4122C50.8342 0 52.0908 0.832971 52.6275 2.13159L59.7004 19.2463L62.6212 0.818248C62.6958 0.350374 63.1057 0 63.5722 0H68.6272C69.1794 0 69.5882 0.482597 69.5003 1.03427Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.0246 16.7876L46.9032 29.1891C46.8244 29.6514 46.3865 29.9999 45.8842 29.9999H40.4624C39.8704 29.9999 39.4312 29.5214 39.5251 28.976L42.9734 8.7804H44.1449C44.785 8.7804 45.3529 9.11893 45.6086 9.65267L49.0246 16.7876Z"
      />
    </svg>
  );
};

Icon.LogoFinance = function LogoFinance(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={89}
      height={35}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#F0E7D6"
          d="M0 14.508v-.533c1.221 0 1.567-.162 1.567-1.299V2.288c0-1.137-.346-1.3-1.567-1.3V.457h10.598l.046 3.547h-.414C9.93 1.5 9.193 1.128 6.36 1.128H4.7v5.798h1.89c1.843 0 1.913-.371 2.096-1.81h.438V9.36h-.438c-.184-1.438-.253-1.786-2.096-1.786H4.7v5.101c0 1.067.277 1.3 2.028 1.3v.532H0v.001ZM10.904 4.908V4.42h4.148v8.302c0 1.135.183 1.298 1.151 1.298v.487h-5.299v-.487c.99 0 1.176-.162 1.176-1.299V6.208c0-1.137-.184-1.3-1.176-1.3ZM13.531 0c.922 0 1.66.719 1.66 1.647s-.738 1.623-1.66 1.623c-.92 0-1.704-.696-1.704-1.623S12.587 0 13.53 0ZM22.102 14.508h-5.299v-.487c.991 0 1.176-.162 1.176-1.299V6.208c0-1.137-.184-1.3-1.176-1.3v-.486h4.148v1.81c.46-.998 1.659-2.04 3.11-2.04 2.12 0 3.157 1.53 3.157 3.384v5.148c0 1.136.185 1.3 1.175 1.3v.486h-5.299v-.487c.99 0 1.152-.162 1.152-1.299v-4.73c0-1.623-.668-2.342-1.705-2.342-.645 0-1.244.395-1.59 1.113v5.96c0 1.135.184 1.298 1.152 1.298v.487-.001ZM31.735 5.674c-1.06 0-1.936.672-2.512 1.971l-.461-.185c.622-1.855 2.165-3.269 4.331-3.269 2.351 0 3.78 1.461 3.78 3.757v4.707c0 .58.173 1.072.668 1.256.28.105.29.113.737.112l-.137.487c-.748 0-.807.232-1.913.232-1.014 0-1.982-.51-2.328-1.646-.553.859-1.612 1.646-2.856 1.646-1.36 0-2.512-.88-2.512-2.318 0-1.577 1.337-2.272 3.226-3.037l2.12-.812v-.532c0-1.3-.645-2.366-2.143-2.366v-.003Zm.944 4.01c-.875.371-1.474.859-1.474 1.994 0 .951.575 1.646 1.406 1.646.438 0 .899-.208 1.267-.626V9.22l-1.198.463v.001Z"
        />
        <path
          fill="#F0E7D6"
          d="M43.44 14.508h-5.3v-.487c.991 0 1.176-.162 1.176-1.299V6.208c0-1.137-.184-1.3-1.175-1.3v-.486h4.147v1.81c.461-.998 1.659-2.04 3.11-2.04 2.12 0 3.157 1.53 3.157 3.384v5.148c0 1.136.185 1.3 1.175 1.3v.486h-5.299v-.487c.991 0 1.152-.162 1.152-1.299v-4.73c0-1.623-.668-2.342-1.705-2.342-.644 0-1.243.395-1.59 1.113v5.96c0 1.135.185 1.298 1.153 1.298v.487l-.001-.001ZM55.145 12.63c0-.811-.577-1.16-1.474-1.623l-1.752-.927c-1.106-.557-1.844-1.415-1.844-2.76 0-1.877 1.636-3.13 3.525-3.13 1.198 0 1.912.58 2.282.58.276 0 .368-.208.437-.44h.323l.184 3.037-.437.024c-.231-1.53-1.314-2.574-2.604-2.574-.899 0-1.428.556-1.428 1.32 0 .766.53 1.09 1.267 1.462l1.59.857c1.22.65 2.096 1.554 2.096 2.969 0 1.994-1.637 3.315-3.78 3.315-1.52 0-2.304-.789-2.626-.789-.253 0-.414.325-.484.603h-.346l-.184-3.501.46-.024c.231 1.763 1.522 3.061 3.111 3.061 1.015 0 1.683-.51 1.683-1.46ZM17.357 16.31v.533c-1.151 0-1.613.116-1.613.95v.302l.005 10.48c.116 1.09.462 1.252 1.66 1.252v.533h-6.222v-.533c1.037 0 1.452-.116 1.452-.858v-.394l-.075-10.922-4.7 12.938h-.185L2.396 17.653l.138 10.944v.162c0 .951.714 1.067 1.912 1.067v.533H0v-.533c1.267 0 1.568-.116 1.683-1.229l-.115-10.504v-.278c0-.858-.393-.973-1.568-.973v-.533h5.162l3.787 8.812 3.317-8.812h5.092v.001ZM20.784 21.528c-1.06 0-1.935.672-2.511 1.971l-.462-.184c.623-1.856 2.166-3.27 4.332-3.27 2.35 0 3.78 1.461 3.78 3.757v4.707c0 .58.276.88.668.88.3 0 .46-.115.737-.44l.3.325c-.414.672-1.245 1.321-2.35 1.321-1.015 0-1.982-.51-2.328-1.646-.553.859-1.613 1.646-2.856 1.646-1.36 0-2.512-.88-2.512-2.318 0-1.577 1.336-2.272 3.226-3.037l2.12-.811v-.533c0-1.3-.645-2.366-2.143-2.366v-.002Zm.945 4.012c-.875.37-1.474.858-1.474 1.993 0 .951.575 1.646 1.406 1.646.437 0 .898-.208 1.267-.626v-3.478l-1.198.463v.002Z"
        />
        <path
          fill="#F0E7D6"
          d="M31.798 35c-2.834 0-5.323-.881-5.323-2.597 0-1.182 1.313-1.924 2.95-2.017-.553-.209-1.014-.789-1.014-1.554 0-1.067.83-1.762 1.958-2.087-1.774-.394-3.063-1.646-3.063-3.293 0-1.971 1.89-3.409 4.262-3.409.553 0 1.106.093 1.59.232 1.75 0 3.087 0 4.147-.138l-.414 1.136-2.028-.046c.622.58.99 1.345.99 2.226 0 1.994-1.912 3.431-4.286 3.431-.184 0-.368 0-.553-.023-.576.092-.806.324-.806.626 0 .278.253.44.623.51l3.202.65c2.005.394 3.065 1.182 3.065 2.666 0 2.272-2.741 3.687-5.3 3.687Zm-1.912-4.43c-.899.186-1.406.79-1.406 1.67 0 1.391 1.337 2.156 3.294 2.156 1.751 0 3.295-.533 3.295-1.647 0-.649-.392-1.043-1.498-1.299l-3.686-.88Zm1.681-9.97c-.921 0-1.567 1.159-1.567 2.852 0 1.693.645 2.875 1.567 2.875.922 0 1.59-1.183 1.59-2.875s-.668-2.852-1.59-2.852Z"
        />
        <path
          fill="#F0E7D6"
          d="M39.817 21.528c-1.06 0-1.935.672-2.512 1.971l-.461-.184c.622-1.856 2.166-3.27 4.332-3.27 2.35 0 3.779 1.461 3.779 3.757v4.707c0 .58.276.88.668.88.3 0 .461-.115.738-.44l.3.325c-.415.672-1.245 1.321-2.351 1.321-1.014 0-1.981-.51-2.327-1.646-.553.859-1.613 1.646-2.857 1.646-1.359 0-2.512-.88-2.512-2.318 0-1.577 1.337-2.272 3.226-3.037l2.12-.811v-.533c0-1.3-.644-2.366-2.142-2.366l-.001-.002Zm.945 4.012c-.876.37-1.475.858-1.475 1.993 0 .951.576 1.646 1.406 1.646.438 0 .9-.208 1.267-.626v-3.478l-1.197.463-.001.002ZM52.099 28.484c0-.81-.577-1.159-1.475-1.623l-1.752-.927c-1.105-.557-1.843-1.415-1.843-2.76 0-1.877 1.635-3.13 3.525-3.13 1.198 0 1.912.58 2.281.58.277 0 .368-.208.438-.44h.322l.185 3.037-.438.024c-.23-1.53-1.313-2.574-2.603-2.574-.9 0-1.429.556-1.429 1.321 0 .765.53 1.09 1.267 1.461l1.59.858c1.221.648 2.096 1.553 2.096 2.968 0 1.994-1.635 3.315-3.779 3.315-1.52 0-2.304-.788-2.627-.788-.253 0-.414.324-.483.602h-.346l-.185-3.5.461-.024c.231 1.762 1.522 3.06 3.111 3.06 1.014 0 1.682-.51 1.682-1.46h.002ZM54.726 20.763v-.487h4.147v8.302c0 1.135.184 1.299 1.152 1.299v.486h-5.3v-.486c.991 0 1.176-.163 1.176-1.3v-6.515c0-1.137-.184-1.299-1.175-1.299Zm2.626-4.909c.921 0 1.659.719 1.659 1.647s-.738 1.623-1.66 1.623c-.92 0-1.704-.696-1.704-1.623s.76-1.647 1.705-1.647ZM65.924 30.362h-5.3v-.486c.991 0 1.176-.163 1.176-1.3v-6.515c0-1.137-.184-1.299-1.175-1.299v-.487h4.147v1.81c.461-.998 1.659-2.04 3.11-2.04 2.12 0 3.157 1.53 3.157 3.384v5.149c0 1.135.185 1.299 1.176 1.299v.486h-5.3v-.486c.991 0 1.152-.163 1.152-1.3v-4.73c0-1.623-.668-2.342-1.704-2.342-.645 0-1.244.395-1.59 1.113v5.96c0 1.135.184 1.299 1.152 1.299v.486h-.001ZM77.33 30.594c-2.788 0-5.093-2.064-5.093-5.1 0-3.038 2.42-5.45 4.953-5.45 2.535 0 4.032 2.157 4.056 4.104H75.07v.047c0 2.898 1.59 4.915 3.686 4.915.945 0 1.683-.394 2.305-1.229l.322.255c-.944 1.623-2.464 2.458-4.055 2.458h.001Zm-2.235-7.072h3.755c-.07-1.647-.644-2.829-1.774-2.829s-1.843.951-1.981 2.829ZM85.348 17.307h.184v3.015c.737 0 2.373-.024 3.041-.093l-.138.811h-2.903v6.308c0 1.089.483 1.878 1.452 1.878.69 0 1.129-.325 1.613-.997l.322.302c-.738 1.251-1.913 2.063-3.387 2.063-1.705 0-2.996-1.205-2.996-2.968l.07-6.608H81.5v-.371c1.382-.742 3.041-2.226 3.848-3.339v-.001Z"
        />
        <path
          fill="#000"
          d="M57.375 19.192c2.57 0 4.654-2.097 4.654-4.684s-2.083-4.684-4.654-4.684c-2.57 0-4.654 2.097-4.654 4.684s2.084 4.684 4.654 4.684Z"
        />
        <path
          fill="#fff"
          d="m56.298 15.972.139-2.004.669-.059-.02.31.636-.056a.072.072 0 0 1 .079.078l-.03.425a.08.08 0 0 1-.071.073l-.654.057-.08 1.138a.094.094 0 0 1-.085.088l-.488.043a.085.085 0 0 1-.093-.093h-.002Z"
        />
        <path
          fill="#fff"
          d="m60.656 12.856-.195 2.77a.094.094 0 0 1-.086.088l-.586.05a.098.098 0 0 1-.095-.05l-.014-.027-1.108-2.018a.245.245 0 0 0-.033-.047.227.227 0 0 0-.186-.07l-3.357.296-.04.557.693-.06a.072.072 0 0 1 .078.078l-.03.425a.079.079 0 0 1-.07.073l-.71.063-.042.598 1.07-.094a.072.072 0 0 1 .078.078l-.032.466a.079.079 0 0 1-.072.073l-1.646.144a.094.094 0 0 1-.102-.101l.19-2.753a.105.105 0 0 1 .094-.096l4.252-.375a.336.336 0 0 1 .33.18l.828 1.6.127-1.813a.094.094 0 0 1 .085-.087l.489-.043a.086.086 0 0 1 .092.093l-.002.002Z"
        />
        <path
          fill="#fff"
          d="m58.765 14.553-.086 1.231a.094.094 0 0 1-.085.088l-.488.043a.085.085 0 0 1-.093-.093l.139-2.004.106-.01a.144.144 0 0 1 .14.075l.368.671h-.001Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h88.919v35H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

Icon.LogoPlay = function logoPlay(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="146"
      height="35"
      fill="none"
      viewBox="0 0 146 35"
      {...props}
    >
      <path
        fill="#FAF9F6"
        fillRule="evenodd"
        d="M25.623 33.805l3.719-23.561h7.996l-.56 3.64h7.607c.536 0 .933.47.848 1.003l-.794 5a.943.943 0 01-.922.793h-7.82L33.58 34.054c-.086.54-.558.946-1.1.946h-5.846a1.02 1.02 0 01-1.01-1.195z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FAF9F6"
        fillRule="evenodd"
        d="M81.084 1.207l-5.208 32.828a1.14 1.14 0 01-1.13.965h-7.068c-.468 0-.895-.28-1.087-.712l-.148-.335L55.278 8.726a2.757 2.757 0 00-.346-.595 2.751 2.751 0 00-2.164-1.033H12.295l-1.05 6.608h8.348c.541 0 .94.473.856 1.011l-.803 5.042a.95.95 0 01-.928.8h-8.563l-1.122 7.098h12.909c.539 0 .939.473.854 1.012L21.92 34.2a.952.952 0 01-.932.8H1.132a1.131 1.131 0 01-1.118-1.324L5.165 1.047A1.244 1.244 0 016.382 0h51.266c1.658 0 3.125.972 3.75 2.487l8.252 19.967 3.408-21.5A1.136 1.136 0 0174.168 0h5.897c.644 0 1.121.563 1.019 1.207z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FAF9F6"
        fillRule="evenodd"
        d="M57.195 19.586L54.72 34.054c-.092.54-.603.946-1.189.946h-6.325c-.69 0-1.203-.558-1.094-1.194l4.023-23.562h1.367c.747 0 1.41.395 1.708 1.018l3.985 8.324z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FAF9F6"
        fillRule="evenodd"
        d="M86.147 14.832a1 1 0 01.986-.832h4.78a1 1 0 01.986 1.168l-.851 5a1 1 0 01-.986.832h-4.78a1 1 0 01-.986-1.168l.851-5z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FAF9F6"
        d="M100.778 23.5h-2.34l2.94-13.34h5.72c2.08 0 3.62 1.64 3.62 3.58 0 2.02-1.36 4.76-5.34 4.76h-3.5l-1.1 5zm4.74-7.06c1.72 0 2.76-1.1 2.76-2.46 0-1-.8-1.76-1.9-1.76h-3.1l-.94 4.22h3.18zm7.147 7.06h-2.1l2.94-13.34h2.1l-2.94 13.34zm8.164-9.9c1.4 0 2.56.62 3.2 1.62l.3-1.38h2.1l-2.14 9.66h-2.1l.3-1.28c-.82.98-1.82 1.52-3.04 1.52-2.18 0-3.7-1.46-3.7-4 0-3 1.88-6.14 5.08-6.14zm.32 1.86c-1.9 0-3.2 1.86-3.2 3.86 0 1.56 1 2.56 2.38 2.56 1.04 0 1.96-.62 2.54-1.38l.82-3.74c-.44-.74-1.36-1.3-2.54-1.3zm4.641 11.74l.7-1.84c.22.1.6.16.98.16.52 0 .88-.2 1.3-.8l.76-1.16-1.78-9.72h2.18l1.2 7.24 4.44-7.24h2.32l-7.2 11.4c-.96 1.56-1.98 2.18-3.42 2.18-.52 0-1.08-.08-1.48-.22z"
      ></path>
    </svg>
  );
};

Icon.LogoPod = function LogoPod(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="146"
      height="35"
      fill="none"
      viewBox="0 0 146 35"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M25.623 33.805l3.718-23.561h7.997l-.56 3.64h7.607c.536 0 .932.47.847 1.003l-.794 5a.943.943 0 01-.922.793h-7.819L33.58 34.054c-.086.54-.558.946-1.1.946h-5.847a1.02 1.02 0 01-1.01-1.195z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M81.084 1.207l-5.208 32.828a1.14 1.14 0 01-1.13.965h-7.068c-.468 0-.895-.28-1.087-.712l-.148-.335L55.278 8.726a2.757 2.757 0 00-.346-.595 2.751 2.751 0 00-2.164-1.033H12.295l-1.05 6.608h8.348c.541 0 .94.473.856 1.011l-.803 5.042a.95.95 0 01-.928.8h-8.563l-1.122 7.098h12.909c.539 0 .939.473.854 1.012L21.92 34.2a.952.952 0 01-.932.8H1.132a1.131 1.131 0 01-1.118-1.324L5.165 1.047A1.244 1.244 0 016.382 0h51.266c1.658 0 3.125.972 3.75 2.487l8.252 19.967 3.408-21.5A1.136 1.136 0 0174.168 0h5.897c.644 0 1.121.563 1.019 1.207z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M57.195 19.586L54.72 34.054c-.092.54-.603.946-1.189.946h-6.325c-.69 0-1.203-.558-1.094-1.194l4.023-23.562h1.367c.747 0 1.41.395 1.708 1.018l3.985 8.324z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M86.147 14.832a1 1 0 01.986-.832h4.78a1 1 0 01.986 1.168l-.851 5a1 1 0 01-.986.832h-4.78a1 1 0 01-.986-1.168l.851-5z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M100.778 23.5h-2.34l2.94-13.34h5.72c2.08 0 3.62 1.64 3.62 3.58 0 2.02-1.36 4.76-5.34 4.76h-3.5l-1.1 5zm4.74-7.06c1.72 0 2.76-1.1 2.76-2.46 0-1-.8-1.76-1.9-1.76h-3.1l-.94 4.22h3.18zm9.754 7.3c-2.94 0-4.62-1.82-4.62-4.36 0-3.02 2.3-5.78 5.5-5.78 2.94 0 4.62 1.8 4.62 4.34 0 3.02-2.3 5.8-5.5 5.8zm.08-1.86c1.9 0 3.24-1.88 3.24-3.84 0-1.58-.94-2.58-2.52-2.58-1.9 0-3.24 1.86-3.24 3.84 0 1.58.94 2.58 2.52 2.58zm11.845-8.28c1.4 0 2.56.62 3.2 1.62l1.12-5.06h2.1l-2.96 13.34h-2.1l.3-1.28c-.82.98-1.82 1.52-3.04 1.52-2.18 0-3.7-1.46-3.7-4 0-3 1.88-6.14 5.08-6.14zm.32 1.86c-1.9 0-3.2 1.86-3.2 3.86 0 1.56 1 2.56 2.38 2.56 1.04 0 1.96-.62 2.54-1.38l.82-3.74c-.44-.74-1.36-1.3-2.54-1.3zm11.301-1.86c1.4 0 2.56.62 3.2 1.62l1.12-5.06h2.1l-2.96 13.34h-2.1l.3-1.28c-.82.98-1.82 1.52-3.04 1.52-2.18 0-3.7-1.46-3.7-4 0-3 1.88-6.14 5.08-6.14zm.32 1.86c-1.9 0-3.2 1.86-3.2 3.86 0 1.56 1 2.56 2.38 2.56 1.04 0 1.96-.62 2.54-1.38l.82-3.74c-.44-.74-1.36-1.3-2.54-1.3z"
      ></path>
    </svg>
  );
};

Icon.LogoBook = function LogoBook(props: IconProps) {
  return (
    <svg
      width={142}
      height={35}
      viewBox="0 0 142 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M78.8765 30.6266C78.7926 30.6266 78.7144 30.5895 78.6604 30.5267C78.6064 30.4639 78.5822 30.3798 78.5964 30.297L82.6478 4.70729C82.6691 4.56888 82.7885 4.46614 82.9293 4.46614H92.7484C94.4662 4.46614 96.8865 4.73868 98.6612 6.03714C100.124 7.10588 101.091 9.00791 101.124 10.8828C101.171 13.6182 99.749 16.0653 97.4596 17.2667C98.9584 18.2669 99.9552 20.1419 99.9894 22.1067C100.036 24.8249 98.7152 27.3833 96.4571 28.9514C94.2088 30.4982 91.7075 30.6266 89.1294 30.6266H78.878H78.8765ZM89.7394 25.8694C91.0121 25.8694 92.7498 25.6454 93.7965 24.5766C94.3951 23.9645 94.6909 23.1369 94.6724 22.1167C94.6369 20.062 92.8167 19.3286 91.1259 19.3286H85.5416L84.4978 25.868H89.7394V25.8694ZM91.598 14.8967C93.1224 14.8967 94.243 14.5428 94.927 13.845C95.4645 13.2971 95.7276 12.5223 95.7105 11.5421C95.6849 10.0239 94.3795 9.04358 92.3858 9.04358H87.1613L86.2469 14.8981H91.598V14.8967ZM110.138 31.096C107.975 31.096 105.99 30.3512 104.55 28.9971C102.866 27.4418 101.953 25.2615 101.908 22.6946C101.841 18.8163 103.041 15.4745 105.286 13.2814C106.903 11.7161 109.19 10.8186 111.558 10.8186C113.757 10.8186 115.834 11.5834 117.254 12.9161C118.914 14.45 119.815 16.6303 119.861 19.2187C119.928 23.0955 118.727 26.4387 116.482 28.6318C114.888 30.1743 112.517 31.0946 110.138 31.0946V31.096ZM111.411 15.3233C110.564 15.3233 109.76 15.6401 109.022 16.2665C107.427 17.6263 106.899 20.5671 106.94 22.8658C106.957 23.8403 107.179 24.628 107.619 25.2729C108.19 26.1119 109.163 26.5928 110.286 26.5928C111.134 26.5928 111.937 26.276 112.675 25.6496C114.272 24.2898 114.798 21.349 114.757 19.0503C114.74 18.0757 114.518 17.2881 114.079 16.6432C113.507 15.8042 112.535 15.3233 111.411 15.3233ZM139.345 30.6266C139.444 30.6266 139.536 30.5752 139.587 30.491C139.638 30.4069 139.644 30.3013 139.599 30.2128L134.031 19.1074L141.909 11.7818C141.995 11.7019 142.023 11.5777 141.98 11.4679C141.938 11.358 141.833 11.2866 141.716 11.2866H135.637C135.564 11.2866 135.495 11.3138 135.442 11.3637L128.083 18.2669L130.286 4.32488C130.298 4.24213 130.276 4.15794 130.22 4.09515C130.166 4.03237 130.087 3.99527 130.004 3.99527H125.472C125.333 3.99527 125.213 4.09801 125.191 4.23641L121.075 30.2956C121.062 30.3783 121.087 30.4625 121.141 30.5253C121.195 30.5881 121.274 30.6252 121.357 30.6252H125.889C126.028 30.6252 126.148 30.5239 126.169 30.3855L126.933 25.6454L130.226 22.5804L134.05 30.4639C134.097 30.5624 134.196 30.6237 134.306 30.6237H139.341L139.345 30.6266ZM33.6063 14.6355H27.8258L28.251 11.8645H22.1747L19.3491 29.7962C19.2723 30.2799 19.6321 30.7065 20.117 30.7065H24.5594C24.9704 30.7065 25.3301 30.3969 25.3941 29.9859L27.0038 19.8066H32.9451C33.2906 19.8066 33.5907 19.5469 33.6461 19.203L34.2491 15.3975C34.3131 14.9908 34.013 14.6341 33.6049 14.6341L33.6063 14.6355ZM38.7057 11.866H37.7458L34.9203 29.799C34.8435 30.2827 35.2033 30.7079 35.6882 30.7079H40.1306C40.5415 30.7079 40.9013 30.3983 40.9653 29.9874L42.703 18.9761L39.9045 12.6408C39.6954 12.167 39.2304 11.866 38.7057 11.866ZM60.3219 4.29206H55.8781C55.4686 4.29206 55.1074 4.60027 55.042 5.01264L52.4752 21.2391L46.2581 6.16984C45.786 5.02691 44.6825 4.29349 43.4325 4.29349H4.80886C4.35665 4.29349 3.96275 4.63309 3.89165 5.08398L0.0109412 29.7091C-0.0715364 30.2413 0.322363 30.7079 0.852779 30.7079H15.8125C16.1581 30.7079 16.4595 30.4497 16.515 30.1044L17.1748 25.9293C17.2388 25.5226 16.9373 25.1659 16.532 25.1659H6.8068L7.65149 19.8094H14.1032C14.4474 19.8094 14.7488 19.5511 14.8029 19.2058L15.4072 15.4003C15.4712 14.9937 15.1697 14.637 14.7616 14.637H8.472L9.26407 9.65001H39.7566C40.4036 9.65001 40.9994 9.93967 41.3877 10.4291C41.4957 10.5646 41.5768 10.7187 41.6479 10.8786L50.0592 29.9174L50.1715 30.17C50.3151 30.4953 50.6379 30.7079 50.9906 30.7079H56.3161C56.7427 30.7079 57.101 30.4012 57.1679 29.9802L61.0913 5.20384C61.168 4.7187 60.8097 4.29349 60.3234 4.29349L60.3219 4.29206ZM73.3036 0H71.5275C71.2858 0 71.0796 0.176935 71.0412 0.416652L65.673 34.4292C65.6261 34.7289 65.8565 35 66.1594 35H67.9355C68.1772 35 68.3834 34.8231 68.4218 34.5833L73.79 0.570753C73.8369 0.271108 73.6065 0 73.3036 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.LogoScience = function LogoBook(props: IconProps) {
  return (
    <svg
      width={195}
      height={35}
      viewBox="0 0 195 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6234 33.8047L29.3418 10.2439H37.3381L36.7776 13.8844H44.3853C44.9211 13.8844 45.3175 14.3535 45.2325 14.8871L44.4386 19.8875C44.3665 20.3397 43.9709 20.6801 43.5169 20.6801H35.6978L33.58 34.054C33.4943 34.5934 33.0221 35 32.4806 35H26.6339C25.9957 35 25.5229 34.4411 25.6234 33.8047"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.0836 1.20665L75.8763 34.0354C75.7874 34.5938 75.3118 35 74.7458 35H67.6781C67.2103 35 66.7826 34.7198 66.5915 34.2881L66.443 33.9528L55.2782 8.72567C55.1839 8.51502 55.0746 8.30966 54.9321 8.13055C54.4172 7.48229 53.6269 7.09772 52.7681 7.09772H12.2952L11.2445 13.7061H19.5926C20.1342 13.7061 20.5339 14.1791 20.4489 14.7172L19.6462 19.7592C19.5749 20.2171 19.1739 20.5597 18.7179 20.5597H10.1554L9.0334 27.6575H21.9418C22.4808 27.6575 22.8805 28.1299 22.7955 28.6686L21.9196 34.2002C21.8475 34.6574 21.4466 35 20.9879 35H1.13227C0.427081 35 -0.0943405 34.3812 0.0143654 33.6758L5.16528 1.0472C5.25878 0.450143 5.78214 0 6.38207 0H57.6476C59.3065 0 60.7726 0.971799 61.3987 2.48686L69.6504 22.454L73.0581 0.954623C73.1451 0.408769 73.6233 0 74.1676 0H80.0651C80.7093 0 81.1862 0.56303 81.0836 1.20665"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.1951 19.5856L54.7201 34.054C54.6282 34.5934 54.1173 35 53.5313 35H47.2059C46.5151 35 46.0028 34.4418 46.1123 33.8055L50.1354 10.2439H51.5021C52.2489 10.2439 52.9115 10.6389 53.2098 11.2615L57.1951 19.5856Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.1472 14.8322C86.229 14.3516 86.6455 14 87.133 14H91.913C92.5323 14 93.0027 14.5572 92.8988 15.1678L92.0479 20.1678C91.9661 20.6484 91.5496 21 91.0621 21H86.2821C85.6628 21 85.1924 20.4428 85.2963 19.8322L86.1472 14.8322Z"
        fill="currentColor"
      />
      <path
        d="M105.218 23.5H102.298L99.9975 10.16H102.538L104.198 20.94L110.618 10.16H113.398L105.218 23.5ZM115.903 23.74C112.923 23.74 111.023 22.06 111.023 19.42C111.023 16.26 113.403 13.6 116.543 13.6C119.063 13.6 120.823 15.26 120.823 17.86C120.823 18.38 120.703 19.06 120.623 19.36H113.163C113.143 19.42 113.143 19.58 113.143 19.68C113.143 20.8 114.103 22.02 116.063 22.02C116.963 22.02 117.983 21.74 118.643 21.2L119.323 22.68C118.403 23.32 117.123 23.74 115.903 23.74ZM118.883 17.86H118.923C118.923 17.8 118.943 17.66 118.943 17.6C118.943 16.34 118.083 15.32 116.403 15.32C114.863 15.32 113.623 16.52 113.383 17.86H118.883ZM125.256 23.74C123.696 23.74 122.656 23.12 122.656 21.78C122.656 21.68 122.676 21.4 122.716 21.16L123.936 15.66H122.336L122.756 13.84H124.356L124.936 11.2H127.036L126.456 13.84H128.416L127.996 15.66H126.036L124.936 20.64C124.916 20.76 124.896 20.88 124.896 21C124.896 21.54 125.216 21.88 125.856 21.88C126.156 21.88 126.496 21.74 126.656 21.62L126.776 23.3C126.396 23.58 125.856 23.74 125.256 23.74ZM133.423 23.74C130.443 23.74 128.543 22.06 128.543 19.42C128.543 16.26 130.923 13.6 134.063 13.6C136.583 13.6 138.343 15.26 138.343 17.86C138.343 18.38 138.223 19.06 138.143 19.36H130.683C130.663 19.42 130.663 19.58 130.663 19.68C130.663 20.8 131.623 22.02 133.583 22.02C134.483 22.02 135.503 21.74 136.163 21.2L136.843 22.68C135.923 23.32 134.643 23.74 133.423 23.74ZM136.403 17.86H136.443C136.443 17.8 136.463 17.66 136.463 17.6C136.463 16.34 135.603 15.32 133.923 15.32C132.383 15.32 131.143 16.52 130.903 17.86H136.403ZM147.936 23.5H145.836L147.176 17.44C147.216 17.24 147.256 17.02 147.256 16.82C147.256 15.84 146.476 15.46 145.456 15.46C144.476 15.46 143.536 16.1 142.896 16.76L141.396 23.5H139.296L141.436 13.84H143.536L143.236 15.14C144.036 14.38 145.136 13.6 146.536 13.6C148.336 13.6 149.516 14.5 149.516 16.02C149.516 16.2 149.456 16.62 149.396 16.84L147.936 23.5ZM154.663 23.74C152.903 23.74 151.323 23.14 150.303 22L151.543 20.56C152.103 21.26 153.423 22.06 154.843 22.06C155.943 22.06 156.603 21.46 156.603 20.76C156.603 19.24 151.603 19.54 151.603 16.74C151.603 15.08 152.983 13.6 155.443 13.6C157.083 13.6 158.563 14.26 159.383 15.16L158.243 16.56C157.803 15.9 156.603 15.26 155.383 15.26C154.323 15.26 153.703 15.76 153.703 16.4C153.703 17.82 158.683 17.56 158.683 20.44C158.683 22.22 157.223 23.74 154.663 23.74ZM169.136 23.5H166.616L164.496 19.44L162.776 20.9L162.196 23.5H160.096L163.036 10.16H165.136L163.316 18.36L168.516 13.84H171.196L166.216 18.22L169.136 23.5ZM175.986 13.6C177.386 13.6 178.546 14.22 179.186 15.22L179.486 13.84H181.586L179.446 23.5H177.346L177.646 22.22C176.826 23.2 175.826 23.74 174.606 23.74C172.426 23.74 170.906 22.28 170.906 19.74C170.906 16.74 172.786 13.6 175.986 13.6ZM176.306 15.46C174.406 15.46 173.106 17.32 173.106 19.32C173.106 20.88 174.106 21.88 175.486 21.88C176.526 21.88 177.446 21.26 178.026 20.5L178.846 16.76C178.406 16.02 177.486 15.46 176.306 15.46ZM187.767 23.74C186.387 23.74 185.207 23.12 184.567 22.12L183.447 27.18H181.347L184.307 13.84H186.407L186.127 15.12C186.927 14.14 187.927 13.6 189.147 13.6C191.347 13.6 192.847 15.04 192.847 17.58C192.847 20.6 190.987 23.74 187.767 23.74ZM187.447 21.88C189.347 21.88 190.647 20.02 190.647 18C190.647 16.44 189.667 15.46 188.267 15.46C187.247 15.46 186.307 16.06 185.747 16.82L184.907 20.56C185.347 21.3 186.267 21.88 187.447 21.88Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.LogoEfn = function LogoEfn({
  accentColor,
  ...props
}: IconProps & { accentColor?: string }) {
  return (
    <svg
      width="250"
      height="35"
      viewBox="0 0 250 35"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6234 33.8047L29.3418 10.2439H37.3381L36.7776 13.8844H44.3853C44.9211 13.8844 45.3175 14.3535 45.2325 14.8871L44.4386 19.8875C44.3665 20.3397 43.9709 20.6801 43.5169 20.6801H35.6978L33.58 34.054C33.4943 34.5934 33.0221 35 32.4806 35H26.6339C25.9957 35 25.5229 34.4411 25.6234 33.8047Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.0836 1.20665L75.8763 34.0354C75.7874 34.5938 75.3118 35 74.7458 35H67.6781C67.2103 35 66.7826 34.7198 66.5915 34.2881L66.443 33.9528L55.2782 8.72567C55.1839 8.51502 55.0746 8.30966 54.9321 8.13055C54.4172 7.48229 53.6269 7.09772 52.7681 7.09772H12.2952L11.2445 13.7061H19.5926C20.1342 13.7061 20.5339 14.1791 20.4489 14.7172L19.6462 19.7592C19.5749 20.2171 19.1739 20.5597 18.7179 20.5597H10.1554L9.0334 27.6575H21.9418C22.4808 27.6575 22.8805 28.1299 22.7955 28.6686L21.9196 34.2002C21.8475 34.6574 21.4466 35 20.9879 35H1.13227C0.427081 35 -0.0943405 34.3812 0.0143654 33.6758L5.16528 1.0472C5.25878 0.450143 5.78214 0 6.38207 0H57.6476C59.3065 0 60.7726 0.971799 61.3987 2.48686L69.6504 22.454L73.0581 0.954623C73.1451 0.408769 73.6233 0 74.1676 0H80.0651C80.7093 0 81.1862 0.56303 81.0836 1.20665Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.1951 19.5856L54.7201 34.054C54.6282 34.5934 54.1173 35 53.5313 35H47.2059C46.5151 35 46.0028 34.4418 46.1123 33.8055L50.1354 10.2439H51.5021C52.2489 10.2439 52.9115 10.6389 53.2098 11.2615L57.1951 19.5856Z"
      />
      <path
        className={accentColor ? accentColor : ""}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.1472 14.8322C86.229 14.3516 86.6455 14 87.133 14H91.913C92.5323 14 93.0027 14.5572 92.8988 15.1678L92.0479 20.1678C91.9661 20.6484 91.5496 21 91.0621 21H86.2821C85.6628 21 85.1924 20.4428 85.2963 19.8322L86.1472 14.8322Z"
      />
      <path d="M107.578 23.5H98.4375L101.378 10.16H110.518L110.078 12.22H103.278L102.518 15.66H109.178L108.718 17.72H102.058L101.238 21.44H108.038L107.578 23.5ZM118.961 23.5H116.441L114.321 19.44L112.601 20.9L112.021 23.5H109.921L112.861 10.16H114.961L113.141 18.36L118.341 13.84H121.021L116.041 18.22L118.961 23.5ZM125.37 23.74C122.43 23.74 120.75 21.92 120.75 19.38C120.75 16.36 123.05 13.6 126.25 13.6C129.19 13.6 130.87 15.4 130.87 17.94C130.87 20.96 128.57 23.74 125.37 23.74ZM125.45 21.88C127.35 21.88 128.69 20 128.69 18.04C128.69 16.46 127.75 15.46 126.17 15.46C124.27 15.46 122.93 17.32 122.93 19.3C122.93 20.88 123.87 21.88 125.45 21.88ZM140.494 23.5H138.394L139.734 17.44C139.774 17.24 139.814 17.02 139.814 16.82C139.814 15.84 139.034 15.46 138.014 15.46C137.034 15.46 136.094 16.1 135.454 16.76L133.954 23.5H131.854L133.994 13.84H136.094L135.794 15.14C136.594 14.38 137.694 13.6 139.094 13.6C140.894 13.6 142.074 14.5 142.074 16.02C142.074 16.2 142.014 16.62 141.954 16.84L140.494 23.5ZM148.221 23.74C145.281 23.74 143.601 21.92 143.601 19.38C143.601 16.36 145.901 13.6 149.101 13.6C152.041 13.6 153.721 15.4 153.721 17.94C153.721 20.96 151.421 23.74 148.221 23.74ZM148.301 21.88C150.201 21.88 151.541 20 151.541 18.04C151.541 16.46 150.601 15.46 149.021 15.46C147.121 15.46 145.781 17.32 145.781 19.3C145.781 20.88 146.721 21.88 148.301 21.88ZM168.666 23.5H166.566L167.926 17.34C167.946 17.24 167.986 17 167.986 16.82C167.986 15.94 167.306 15.46 166.486 15.46C165.646 15.46 164.786 16.08 164.226 16.76L162.726 23.5H160.626L161.986 17.34C162.046 17.12 162.066 16.96 162.066 16.76C162.066 16 161.526 15.46 160.546 15.46C159.706 15.46 158.866 16.1 158.306 16.76L156.806 23.5H154.706L156.846 13.84H158.946L158.646 15.14C159.186 14.56 160.226 13.6 161.626 13.6C163.446 13.6 164.266 14.92 164.266 15.48C164.266 15.5 164.266 15.5 164.266 15.52C165.046 14.58 166.126 13.6 167.566 13.6C168.966 13.6 170.246 14.44 170.246 16.02C170.246 16.26 170.166 16.64 170.126 16.84L168.666 23.5ZM174.965 12.66C174.285 12.66 173.785 12.14 173.785 11.54C173.785 10.6 174.605 10.06 175.265 10.06C175.945 10.06 176.445 10.56 176.445 11.18C176.445 12.12 175.625 12.66 174.965 12.66ZM173.485 23.5H171.385L173.525 13.84H175.625L173.485 23.5ZM185.25 23.5H182.73L180.61 19.44L178.89 20.9L178.31 23.5H176.21L179.15 10.16H181.25L179.43 18.36L184.63 13.84H187.31L182.33 18.22L185.25 23.5ZM192.099 13.6C193.499 13.6 194.659 14.22 195.299 15.22L195.599 13.84H197.699L195.559 23.5H193.459L193.759 22.22C192.939 23.2 191.939 23.74 190.719 23.74C188.539 23.74 187.019 22.28 187.019 19.74C187.019 16.74 188.899 13.6 192.099 13.6ZM192.419 15.46C190.519 15.46 189.219 17.32 189.219 19.32C189.219 20.88 190.219 21.88 191.599 21.88C192.639 21.88 193.559 21.26 194.139 20.5L194.959 16.76C194.519 16.02 193.599 15.46 192.419 15.46ZM206.92 23.5H204.82L206.16 17.44C206.2 17.24 206.24 17.02 206.24 16.82C206.24 15.84 205.46 15.46 204.44 15.46C203.46 15.46 202.52 16.1 201.88 16.76L200.38 23.5H198.28L200.42 13.84H202.52L202.22 15.14C203.02 14.38 204.12 13.6 205.52 13.6C207.32 13.6 208.5 14.5 208.5 16.02C208.5 16.2 208.44 16.62 208.38 16.84L206.92 23.5ZM215.087 13.6C216.487 13.6 217.647 14.22 218.287 15.22L218.587 13.84H220.687L218.547 23.5H216.447L216.747 22.22C215.927 23.2 214.927 23.74 213.707 23.74C211.527 23.74 210.007 22.28 210.007 19.74C210.007 16.74 211.887 13.6 215.087 13.6ZM215.407 15.46C213.507 15.46 212.207 17.32 212.207 19.32C212.207 20.88 213.207 21.88 214.587 21.88C215.627 21.88 216.547 21.26 217.127 20.5L217.947 16.76C217.507 16.02 216.587 15.46 215.407 15.46ZM223.368 23.5H221.268L224.208 10.16H226.308L223.368 23.5ZM231.352 23.74C228.372 23.74 226.472 22.06 226.472 19.42C226.472 16.26 228.852 13.6 231.992 13.6C234.512 13.6 236.272 15.26 236.272 17.86C236.272 18.38 236.152 19.06 236.072 19.36H228.612C228.592 19.42 228.592 19.58 228.592 19.68C228.592 20.8 229.552 22.02 231.512 22.02C232.412 22.02 233.432 21.74 234.092 21.2L234.772 22.68C233.852 23.32 232.572 23.74 231.352 23.74ZM234.332 17.86H234.372C234.372 17.8 234.392 17.66 234.392 17.6C234.392 16.34 233.532 15.32 231.852 15.32C230.312 15.32 229.072 16.52 228.832 17.86H234.332ZM245.865 23.5H243.765L245.105 17.44C245.145 17.24 245.185 17.02 245.185 16.82C245.185 15.84 244.405 15.46 243.385 15.46C242.405 15.46 241.465 16.1 240.825 16.76L239.325 23.5H237.225L239.365 13.84H241.465L241.165 15.14C241.965 14.38 243.065 13.6 244.465 13.6C246.265 13.6 247.445 14.5 247.445 16.02C247.445 16.2 247.385 16.62 247.325 16.84L245.865 23.5Z" />
    </svg>
  );
};

Icon.AngleRight = function AngleRight(props: IconProps) {
  return (
    <svg
      width="9"
      height="18"
      viewBox="0 0 9 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0.236032 1.39731L7.15253 8.42481C7.30422 8.57814 7.38931 8.78512 7.38931 9.00081C7.38931 9.2165 7.30422 9.42348 7.15253 9.57681L0.237533 16.6043C0.0859195 16.7586 0.000965082 16.9663 0.000965085 17.1826C0.000965087 17.3989 0.0859195 17.6065 0.237533 17.7608C0.311599 17.8368 0.400122 17.8972 0.497888 17.9384C0.595653 17.9796 0.700682 18.0009 0.806784 18.0009C0.912885 18.0009 1.01791 17.9796 1.11568 17.9384C1.21344 17.8972 1.30197 17.8368 1.37603 17.7608L8.29103 10.7348C8.74542 10.272 9 9.64938 9 9.00081C9 8.35225 8.74542 7.72959 8.29103 7.26681L1.37603 0.240812C1.30194 0.164609 1.21333 0.104035 1.11542 0.0626733C1.01752 0.0213112 0.912315 9.64447e-08 0.806032 9.77121e-08C0.69975 9.89795e-08 0.594547 0.0213112 0.496643 0.0626733C0.398739 0.104035 0.310121 0.164609 0.236032 0.240812C0.0844187 0.395095 -0.000535719 0.602752 -0.000535717 0.819062C-0.000535714 1.03537 0.0844187 1.24303 0.236032 1.39731Z" />
    </svg>
  );
};

Icon.AngleLeft = function AngleLeft(props: IconProps) {
  return <Icon.AngleRight className="rotate-180" {...props} />;
};

Icon.ExternalLink = function ExternalLink(props: IconProps) {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.4809 5.86199C10.3442 5.86199 10.213 5.91632 10.1163 6.01301C10.0196 6.10971 9.96529 6.24086 9.96529 6.37762V8.45322C9.96484 8.85411 9.80538 9.23845 9.52192 9.52192C9.23845 9.80538 8.85411 9.96484 8.45322 9.96529H2.54674C2.14585 9.96484 1.76152 9.80538 1.47805 9.52192C1.19458 9.23845 1.03512 8.85411 1.03467 8.45322V2.54674C1.03512 2.14585 1.19458 1.76152 1.47805 1.47805C1.76152 1.19458 2.14585 1.03512 2.54674 1.03467H4.62234C4.7591 1.03467 4.89025 0.980343 4.98695 0.883645C5.08364 0.786946 5.13797 0.655795 5.13797 0.519043C5.13797 0.382291 5.08364 0.251139 4.98695 0.154441C4.89025 0.0577426 4.7591 0.00341797 4.62234 0.00341797H2.54674C1.87245 0.00421399 1.22601 0.272426 0.749218 0.749218C0.272426 1.22601 0.00421399 1.87245 0.00341797 2.54674V8.45322C0.00421399 9.12751 0.272426 9.77395 0.749218 10.2507C1.22601 10.7275 1.87245 10.9957 2.54674 10.9965H8.45322C9.12751 10.9957 9.77395 10.7275 10.2507 10.2507C10.7275 9.77395 10.9957 9.12751 10.9965 8.45322V6.37762C10.9965 6.24086 10.9422 6.10971 10.8455 6.01301C10.7488 5.91632 10.6177 5.86199 10.4809 5.86199Z" />
      <path d="M10.4699 4.35652e-08H7.26448C7.12946 -2.58495e-05 6.99981 0.0529105 6.9034 0.147436C6.80699 0.241961 6.7515 0.370533 6.74885 0.505527C6.74348 0.794922 6.9869 1.03125 7.27608 1.03125H9.23825L5.13172 5.13906C5.03503 5.23576 4.98071 5.36691 4.98071 5.50365C4.98071 5.6404 5.03503 5.77155 5.13172 5.86824C5.22842 5.96493 5.35957 6.01925 5.49631 6.01925C5.63306 6.01925 5.76421 5.96493 5.8609 5.86824L9.96872 1.76172V3.73098C9.96872 3.86773 10.023 3.99888 10.1197 4.09558C10.2164 4.19228 10.3476 4.2466 10.4843 4.2466C10.6211 4.2466 10.7522 4.19228 10.8489 4.09558C10.9456 3.99888 11 3.86773 11 3.73098V0.529805C11 0.460212 10.9863 0.391301 10.9596 0.327008C10.933 0.262715 10.8939 0.2043 10.8447 0.1551C10.7955 0.105901 10.7371 0.0668799 10.6728 0.0402673C10.6085 0.0136548 10.5395 -2.81775e-05 10.4699 4.35652e-08Z" />
    </svg>
  );
};

Icon.Close = function Close(props: IconProps) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="2.48047"
        y="0.5"
        width="26.25"
        height="2.8"
        rx="1.4"
        transform="rotate(45 2.48047 0.5)"
      />
      <rect
        x="0.5"
        y="19.0615"
        width="26.25"
        height="2.8"
        rx="1.4"
        transform="rotate(-45 0.5 19.0615)"
      />
    </svg>
  );
};

Icon.Podcast = function Podcast(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="4.79 5.21 22.55 24.48"
      {...props}
    >
      <path d="M18.758 23.201c-.084.97-.242 2.264-.45 3.582-.147.937-.267 1.444-.376 1.806-.177.587-.837 1.101-1.87 1.101-1.034 0-1.695-.514-1.872-1.101-.11-.362-.23-.868-.377-1.806a54.57 54.57 0 0 1-.45-3.582c-.087-1.018-.132-1.655-.051-2.395.042-.381.174-.65.425-.911.481-.501 1.326-.822 2.324-.822.998 0 1.843.32 2.324.822.25.262.383.53.425.912.081.74.036 1.376-.052 2.394Zm-6.876-2.46c.1.093.155.226.147.361-.024.415-.015.817.013 1.272a.148.148 0 0 1-.231.13c-2.018-1.36-3.336-3.661-3.302-6.258.051-3.948 3.257-7.201 7.253-7.354 4.3-.165 7.852 3.242 7.852 7.451 0 2.557-1.31 4.817-3.302 6.161a.148.148 0 0 1-.232-.13c.028-.454.037-.857.013-1.271a.459.459 0 0 1 .147-.363 5.982 5.982 0 0 0 1.932-4.397c0-3.405-2.873-6.161-6.352-6.028-3.201.123-5.783 2.705-5.867 5.866a5.98 5.98 0 0 0 1.93 4.56Zm6.803-5.306c0 1.43-1.175 2.59-2.624 2.59-1.45 0-2.624-1.16-2.624-2.59s1.175-2.59 2.624-2.59c1.45 0 2.624 1.16 2.624 2.59Zm1.108 11.413a.15.15 0 0 1-.2-.162c.058-.381.113-.764.163-1.14a.383.383 0 0 1 .227-.302c3.475-1.499 5.91-4.924 5.91-8.9 0-5.38-4.454-9.751-9.913-9.708-5.34.043-9.699 4.34-9.75 9.612-.04 4.017 2.406 7.485 5.908 8.995.124.054.21.169.228.302.05.376.105.76.163 1.14a.15.15 0 0 1-.2.163c-4.43-1.54-7.603-5.737-7.542-10.645.076-6.059 5.105-10.974 11.241-10.991 6.232-.018 11.308 4.982 11.308 11.131 0 4.848-3.155 8.98-7.543 10.505Z"></path>
    </svg>
  );
};

Icon.Spotify = function Spotify(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 30 30"
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.625 22.563c-.313 0-.625-.125-.875-.313-2.875-2.5-9.063-1.75-11.25-1.313-.688.188-1.438-.312-1.563-1-.187-.687.313-1.375 1-1.562.375-.063 9.063-1.938 13.5 1.875.563.5.625 1.313.125 1.875-.187.25-.562.438-.937.438zm1.563-3.75c-.25 0-.5-.063-.75-.25-5.25-3.75-13.25-1.688-13.313-1.688-.688.188-1.438-.25-1.625-.938-.188-.687.25-1.437.938-1.624.375-.126 9.25-2.438 15.562 2.062.563.438.75 1.25.313 1.813-.313.437-.688.625-1.125.625zm1.625-4.25c-.25 0-.5-.063-.75-.25-6.938-4.626-15.688-1.626-15.813-1.626-.688.25-1.375-.124-1.625-.812-.25-.688.125-1.438.813-1.688.437-.124 10.125-3.437 18.125 1.938.625.375.75 1.188.375 1.813-.313.374-.75.624-1.125.624zM15 30C6.75 30 0 23.25 0 15S6.75 0 15 0s15 6.75 15 15-6.75 15-15 15zm0-27.375C8.187 2.625 2.625 8.188 2.625 15c0 6.813 5.563 12.375 12.375 12.375 6.813 0 12.375-5.563 12.375-12.375 0-6.813-5.563-12.375-12.375-12.375z"
      ></path>
    </svg>
  );
};

Icon.Account = function Account(props: IconProps) {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1618_1881)">
        <path d="M9 0.5C4.02917 0.5 0 4.52917 0 9.5C0 14.4708 4.02917 18.5 9 18.5C13.9708 18.5 18 14.4708 18 9.5C18 4.52917 13.9708 0.5 9 0.5ZM4.44851 15.7145C4.59418 13.327 6.57672 11.4286 9 11.4286C11.4233 11.4286 13.4058 13.327 13.5515 15.7145C12.2739 16.653 10.7032 17.2143 9 17.2143C7.29681 17.2143 5.72609 16.653 4.44851 15.7145ZM6.75 7.89286C6.75 6.65234 7.75948 5.64286 9 5.64286C10.2405 5.64286 11.25 6.65234 11.25 7.89286C11.25 9.13338 10.2405 10.1429 9 10.1429C7.75948 10.1429 6.75 9.13338 6.75 7.89286ZM14.6884 14.6925C14.2691 12.8442 12.9821 11.3244 11.2688 10.6011C12.0423 9.95199 12.5357 8.97893 12.5357 7.89286C12.5357 5.94355 10.9493 4.35714 9 4.35714C7.0507 4.35714 5.46429 5.94355 5.46429 7.89286C5.46429 8.97893 5.95774 9.95199 6.73116 10.6011C5.01792 11.3244 3.73095 12.8442 3.31158 14.6925C2.05788 13.3201 1.28571 11.5008 1.28571 9.5C1.28571 5.24609 4.74609 1.78571 9 1.78571C13.2539 1.78571 16.7143 5.24609 16.7143 9.5C16.7143 11.5008 15.9421 13.3201 14.6884 14.6925Z" />
      </g>
      <defs>
        <clipPath id="clip0_1618_1881">
          <rect width="18" height="18" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

Icon.Loading = function Loading(props: IconProps) {
  return (
    <svg
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 1024 1024"
      {...props}
    >
      <path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z" />
    </svg>
  );
};

Icon.Logout = function Logout(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.28802 2.34307C4.84475 -0.275304 8.73081 -0.69835 11.718 1.06986C12.1331 1.31554 12.275 1.85925 12.0352 2.28429C11.7953 2.70933 11.2643 2.85472 10.8494 2.60906C8.52544 1.2335 5.50257 1.56522 3.51552 3.60017C1.14276 6.03013 1.14276 9.96989 3.51552 12.3999C5.50257 14.4348 8.52544 14.7665 10.8494 13.3909C11.2643 13.1453 11.7953 13.2906 12.0352 13.7157C12.275 14.1408 12.1331 14.6844 11.718 14.9301C8.73081 16.6983 4.84475 16.2753 2.28802 13.657C-0.762674 10.5327 -0.762674 5.4673 2.28802 2.34307ZM13.2739 4.70475C13.6128 4.35761 14.1624 4.35761 14.5014 4.70475L16.1429 6.38583C16.2978 6.5445 16.4487 6.6989 16.566 6.84042C16.6948 6.99589 16.8334 7.19313 16.915 7.45065C17.0283 7.80772 17.0283 8.19235 16.915 8.54933C16.8334 8.80694 16.6948 9.00418 16.566 9.15956C16.4487 9.30108 16.2978 9.45557 16.1429 9.61415L14.5014 11.2952C14.1624 11.6424 13.6128 11.6424 13.2739 11.2952C12.9349 10.9481 12.9349 10.3853 13.2739 10.0382L14.3961 8.88889H7.81179C7.33241 8.88889 6.94381 8.49093 6.94381 7.99999C6.94381 7.50905 7.33241 7.11109 7.81179 7.11109H14.3961L13.2739 5.96185C12.9349 5.61471 12.9349 5.05189 13.2739 4.70475Z"
      />
    </svg>
  );
};

Icon.Check = function Check(props: IconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2711_1683)">
        <path d="M9 0C4.0374 0 0 4.0374 0 9C0 13.9626 4.0374 18 9 18C13.9626 18 18 13.9626 18 9C18 4.0374 13.9626 0 9 0ZM9 16.3636C4.93964 16.3636 1.63636 13.0603 1.63636 9C1.63636 4.93969 4.93964 1.63636 9 1.63636C13.0604 1.63636 16.3636 4.93969 16.3636 9C16.3636 13.0603 13.0603 16.3636 9 16.3636Z" />
        <path d="M12.3749 5.81823L7.74651 10.4466L5.62523 8.32525C5.30576 8.00578 4.78769 8.00572 4.46816 8.32519C4.14863 8.64472 4.14863 9.16274 4.46816 9.48227L7.16794 12.1822C7.32138 12.3356 7.52947 12.4218 7.74645 12.4218H7.74651C7.96349 12.4218 8.17158 12.3356 8.32502 12.1822L13.532 6.97536C13.8515 6.65583 13.8515 6.13781 13.532 5.81829C13.2125 5.49876 12.6944 5.4987 12.3749 5.81823Z" />
      </g>
      <defs>
        <clipPath id="clip0_2711_1683">
          <rect width="18" height="18" />
        </clipPath>
      </defs>
    </svg>
  );
};

Icon.Pages = function Pages(props: IconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14.5044 16.5H1.5V3.49561C1.5 3.15061 1.22 2.87061 0.875 2.87061C0.53 2.87061 0.25 3.15061 0.25 3.49561V17.125C0.25 17.4706 0.53 17.75 0.875 17.75H14.5044C14.85 17.75 15.1294 17.4706 15.1294 17.125C15.1294 16.7794 14.8494 16.5 14.5044 16.5Z" />
      <path d="M17.1255 0.25H3.49609C3.15109 0.25 2.87109 0.53 2.87109 0.875V14.5044C2.87109 14.85 3.15109 15.1294 3.49609 15.1294H17.1255C17.4711 15.1294 17.7505 14.85 17.7505 14.5044V0.875C17.7505 0.53 17.4711 0.25 17.1255 0.25ZM16.5005 13.8794H4.12109V1.5H16.5005V13.8794Z" />
      <path d="M6.90234 4.90747H13.7173C14.063 4.90747 14.3423 4.62747 14.3423 4.28247C14.3423 3.93747 14.063 3.65747 13.7173 3.65747H6.90234C6.55734 3.65747 6.27734 3.93747 6.27734 4.28247C6.27734 4.62747 6.55734 4.90747 6.90234 4.90747Z" />
      <path d="M6.90234 8.31439H13.7173C14.063 8.31439 14.3423 8.03439 14.3423 7.68939C14.3423 7.34439 14.063 7.06439 13.7173 7.06439H6.90234C6.55734 7.06439 6.27734 7.34439 6.27734 7.68939C6.27734 8.03439 6.55734 8.31439 6.90234 8.31439Z" />
      <path d="M6.90234 11.7213H13.7173C14.063 11.7213 14.3423 11.4419 14.3423 11.0963C14.3423 10.7506 14.063 10.4713 13.7173 10.4713H6.90234C6.55734 10.4713 6.27734 10.7506 6.27734 11.0963C6.27734 11.4419 6.55734 11.7213 6.90234 11.7213Z" />
    </svg>
  );
};

Icon.Topic = function Topic(props: IconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0410156 8.99996C0.0410156 4.05241 4.0518 0.041626 8.99935 0.041626C13.9469 0.041626 17.9577 4.05241 17.9577 8.99996C17.9577 13.9475 13.9469 17.9583 8.99935 17.9583C7.78593 17.9583 6.62727 17.7167 5.57022 17.2784C5.07162 17.0716 4.59589 16.8212 4.14777 16.532C4.04458 16.5408 3.88527 16.5646 3.66017 16.6094C3.20371 16.7 2.54085 16.8633 1.66407 17.1029C1.44762 17.162 1.21607 17.1005 1.05741 16.9419C0.898741 16.7832 0.837307 16.5517 0.896449 16.3352C1.136 15.4585 1.29926 14.7956 1.38995 14.3391C1.43467 14.114 1.45854 13.9547 1.46729 13.8515C1.17808 13.4034 0.927699 12.9277 0.720966 12.4291C0.282632 11.372 0.0410156 10.2135 0.0410156 8.99996ZM8.99935 1.29163C4.74215 1.29163 1.29102 4.74276 1.29102 8.99996C1.29102 10.0462 1.49912 11.0424 1.87562 11.9503C2.0701 12.4193 2.30962 12.865 2.58889 13.2822C2.69437 13.4398 2.71137 13.6065 2.71683 13.6741C2.72415 13.7648 2.72077 13.8583 2.71388 13.9443C2.69994 14.1184 2.66527 14.3346 2.61598 14.5827C2.5596 14.8665 2.47967 15.2135 2.37688 15.6225C2.78574 15.5196 3.13277 15.4397 3.4166 15.3833C3.66468 15.334 3.88091 15.2994 4.05499 15.2855C4.14107 15.2785 4.23454 15.2751 4.3252 15.2825C4.39289 15.288 4.55958 15.305 4.71713 15.4105C5.13431 15.6897 5.58005 15.9292 6.04897 16.1236C6.95692 16.5001 7.9531 16.7083 8.99935 16.7083C13.2565 16.7083 16.7077 13.2571 16.7077 8.99996C16.7077 4.74276 13.2565 1.29163 8.99935 1.29163Z"
        // fill="#756962"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.29297 7.2583C5.29297 6.91313 5.57279 6.6333 5.91797 6.6333H12.9093C13.2545 6.6333 13.5343 6.91313 13.5343 7.2583C13.5343 7.60349 13.2545 7.88333 12.9093 7.88333H5.91797C5.57279 7.88333 5.29297 7.60349 5.29297 7.2583Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21133 4.94185C8.55125 5.00179 8.77825 5.32596 8.71833 5.66589L7.50425 12.551C7.44433 12.891 7.12018 13.1179 6.78025 13.058C6.44031 12.9981 6.21333 12.6739 6.27327 12.334L7.48733 5.44882C7.54725 5.10889 7.87141 4.88192 8.21133 4.94185Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1274 4.94185C11.4673 5.00179 11.6943 5.32596 11.6344 5.66589L10.4203 12.551C10.3604 12.891 10.0362 13.1179 9.69628 13.058C9.35636 12.9981 9.12936 12.6739 9.18928 12.334L10.4034 5.44882C10.4633 5.10889 10.7874 4.88192 11.1274 4.94185Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.45898 10.6666C4.45898 10.3215 4.7388 10.0416 5.08398 10.0416H12.0754C12.4205 10.0416 12.7004 10.3215 12.7004 10.6666C12.7004 11.0118 12.4205 11.2916 12.0754 11.2916H5.08398C4.7388 11.2916 4.45898 11.0118 4.45898 10.6666Z"
      />
    </svg>
  );
};

Icon.Facebook = function Facebook(props: IconProps) {
  return (
    <svg
      width="53"
      height="53"
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M53 26.5C53 11.8629 41.1371 0 26.5 0C11.8629 0 0 11.8629 0 26.5C0 41.1371 11.8629 53 26.5 53C26.6553 53 26.8105 53 26.9658 52.9896V32.3693H21.2725V25.734H26.9658V20.848C26.9658 15.1857 30.4232 12.101 35.4748 12.101C37.8971 12.101 39.9777 12.277 40.5781 12.3598V18.2809H37.1C34.3568 18.2809 33.8186 19.5852 33.8186 21.5002V25.7236H40.3918L39.5326 32.359H33.8186V51.9752C44.8947 48.7973 53 38.601 53 26.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.LinkedIn = function LinkedIn(props: IconProps) {
  return (
    <svg
      width="53"
      height="53"
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.5 0C11.8667 0 0 11.8667 0 26.5C0 41.1333 11.8667 53 26.5 53C41.1333 53 53 41.1333 53 26.5C53 11.8667 41.1333 0 26.5 0ZM18.7994 40.0605H12.3455V20.6437H18.7994V40.0605ZM15.5726 17.9923H15.5306C13.3648 17.9923 11.9641 16.5014 11.9641 14.6382C11.9641 12.7328 13.4077 11.2832 15.6155 11.2832C17.8233 11.2832 19.1819 12.7328 19.224 14.6382C19.224 16.5014 17.8233 17.9923 15.5726 17.9923ZM42.071 40.0605H35.6179V29.673C35.6179 27.0625 34.6834 25.2821 32.3482 25.2821C30.5654 25.2821 29.5036 26.483 29.0369 27.6423C28.8663 28.0572 28.8247 28.637 28.8247 29.2173V40.0605H22.3711C22.3711 40.0605 22.4556 22.4653 22.3711 20.6437H28.8247V23.3929C29.6823 22.0699 31.2168 20.188 34.6409 20.188C38.8871 20.188 42.071 22.9631 42.071 28.927V40.0605Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.Twitter = function Twitter(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      fill="none"
      viewBox="0 0 35 35"
      {...props}
    >
      <defs>
        <mask id="cutout-mask">
          <rect width="35" height="35" fill="white" />
          <path
            d="m19.415 15.916 7.491-8.708h-1.775l-6.505 7.561-5.195-7.561H7.438l7.857 11.434-7.857 9.132h1.776l6.87-7.985 5.486 7.985h5.992zM9.854 8.544h2.726l12.552 17.954h-2.727z"
            fill="black"
          />
        </mask>
      </defs>

      {/* Circle with currentColor, masked to cut out the white path */}
      <circle
        cx="17.5"
        cy="17.5"
        r="17.5"
        fill="currentColor"
        mask="url(#cutout-mask)"
      />
    </svg>
  );
};

Icon.Bluesky = function Twitter(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      fill="none"
      viewBox="0 0 35 35"
    >
      <g clipPath="url(#clip0_5185_5767)">
        <path
          fill="currentColor"
          d="M17.5 0C7.835 0 0 7.835 0 17.5 0 27.166 7.835 35 17.5 35 27.166 35 35 27.166 35 17.5 35 7.835 27.166 0 17.5 0m9.74 16.571c-.736 2.631-3.42 3.302-5.805 2.897 4.17.71 5.232 3.061 2.94 5.414-4.352 4.466-6.255-1.121-6.744-2.552-.09-.263-.131-.385-.131-.281 0-.104-.043.018-.131.281-.488 1.431-2.392 7.018-6.744 2.552-2.292-2.351-1.23-4.704 2.94-5.414-2.385.406-5.069-.264-5.805-2.897-.212-.757-.573-5.418-.573-6.048 0-3.153 2.765-2.163 4.471-.881 2.366 1.776 4.91 5.375 5.842 7.307.934-1.932 3.478-5.531 5.842-7.307 1.706-1.282 4.471-2.272 4.471.882 0 .63-.361 5.292-.573 6.047"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_5185_5767">
          <path fill="#fff" d="M0 0h35v35H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

Icon.Email = function Email(props: IconProps) {
  return (
    <svg
      width="53"
      height="53"
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5 0C41.1356 0 53 11.8644 53 26.5C53 41.1356 41.1356 53 26.5 53C11.8644 53 0 41.1356 0 26.5C0 11.8644 11.8644 0 26.5 0ZM43.3213 36.773V17.0778L33.4731 26.9253L43.3213 36.773ZM11.7826 37.1742H41.2181L32.2217 28.1779L28.793 31.6061C28.6267 31.7719 28.4015 31.865 28.1667 31.8649H24.8335C24.7172 31.865 24.602 31.8422 24.4946 31.7978C24.3871 31.7534 24.2894 31.6883 24.2071 31.6061L20.7785 28.1779L11.7821 37.1742H11.7826ZM9.67871 17.0772V36.7735L19.5269 26.9253L9.67871 17.0772ZM42.0694 15.8258H10.9312L25.2003 30.0948H27.8003L42.0694 15.8258Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.ClipboardDocument = function ClipboardDocument({
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
      />
    </svg>
  );
};

Icon.ClipboardDocumentCheck = function ClipboardDocumentCheck({
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
      />
    </svg>
  );
};

Icon.Up = function Up({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 227 315"
      className={classNames(className)}
      fill="none"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M132.272 295.727V64.094l61.817 61.817c7.331 7.332 19.217 7.332 26.549 0a18.721 18.721 0 0 0 5.498-13.275c0-4.804-1.834-9.609-5.499-13.273L126.773 5.499c-7.33-7.331-19.217-7.331-26.548 0L6.361 99.363c-7.33 7.33-7.33 19.217 0 26.548 7.33 7.332 19.217 7.332 26.548 0l61.818-61.817v231.633c0 10.368 8.405 18.773 18.772 18.773 10.368 0 18.773-8.405 18.773-18.773Z"
      />
    </svg>
  );
};

Icon.Clock = function Clock({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </svg>
  );
};

Icon.ChevronDown = function ChevronDown({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m19.5 8.25-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
};

Icon.PlusCircle = function PlusCircle({ className, ...rest }: IconProps) {
  return (
    <svg
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        d="M23.2954 10.2273H14.7727V1.70455C14.7727 0.763633 14.009 0 13.0681 0H11.9318C10.9909 0 10.2273 0.763633 10.2273 1.70455V10.2273H1.70455C0.763633 10.2273 0 10.9909 0 11.9318V13.0681C0 14.009 0.763633 14.7727 1.70455 14.7727H10.2273V23.2954C10.2273 24.2363 10.9909 24.9999 11.9318 24.9999H13.0681C14.009 24.9999 14.7727 24.2363 14.7727 23.2954V14.7727H23.2954C24.2363 14.7727 24.9999 14.009 24.9999 13.0681V11.9318C24.9999 10.9909 24.2363 10.2273 23.2954 10.2273Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.CheckCircle = function CheckCircle({ className, ...rest }: IconProps) {
  return (
    <svg
      height="417pt"
      viewBox="0 -46 417.81333 417"
      width="417pt"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("size-10", className)}
      {...rest}
    >
      <path d="m159.988281 318.582031c-3.988281 4.011719-9.429687 6.25-15.082031 6.25s-11.09375-2.238281-15.082031-6.25l-120.449219-120.46875c-12.5-12.5-12.5-32.769531 0-45.246093l15.082031-15.085938c12.503907-12.5 32.75-12.5 45.25 0l75.199219 75.203125 203.199219-203.203125c12.503906-12.5 32.769531-12.5 45.25 0l15.082031 15.085938c12.5 12.5 12.5 32.765624 0 45.246093zm0 0" />
    </svg>
  );
};

Icon.Moon = function Moon({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
      />
    </svg>
  );
};

Icon.Sun = function Sun({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
      />
    </svg>
  );
};

Icon.Computer = function Computer({ className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={classNames("size-6", className)}
      {...rest}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
      />
    </svg>
  );
};

Icon.Bookmark = function Bookmark({ className, ...rest }: IconProps) {
  return (
    <svg
      width={25}
      height={31}
      viewBox="0 0 25 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className)}
      {...rest}
    >
      <path
        d="M23.0384 0H1.96157C0.878233 0 0 0.867452 0 1.93749V29.0624C0 29.8315 0.46054 30.5278 1.17363 30.8367C1.88666 31.1458 2.71721 31.0088 3.29011 30.4879L12.5 22.1139L21.7099 30.4879C22.0793 30.8237 22.5558 31 23.0388 30.9999C23.305 30.9999 23.5731 30.9464 23.8264 30.8367C24.5394 30.5277 25 29.8314 25 29.0623V1.93749C25 0.867452 24.1218 0 23.0384 0ZM21.0769 24.6455L13.8285 18.055C13.4531 17.7137 12.9766 17.543 12.5 17.543C12.0234 17.543 11.5469 17.7137 11.1715 18.055L3.92315 24.6455V3.87499H21.0769V24.6455Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.BookmarkSolid = function BookmarkSolid({ className, ...rest }: IconProps) {
  return (
    <svg
      width={25}
      height={31}
      viewBox="0 0 25 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className)}
      {...rest}
    >
      <path
        d="M1.96157 0H23.0384C24.1218 0 25 0.867452 25 1.93749V29.0623C25 29.8314 24.5394 30.5277 23.8264 30.8367C23.5731 30.9464 23.305 30.9999 23.0388 30.9999C22.5558 31 22.0793 30.8237 21.7099 30.4879L12.5 22.1139L3.29011 30.4879C2.71721 31.0088 1.88666 31.1458 1.17363 30.8367C0.46054 30.5278 0 29.8315 0 29.0624V1.93749C0 0.867452 0.878233 0 1.96157 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

Icon.Accessibility = function Accessibility(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m0 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1c-1.557 0-3.178-.357-4.629-.929L6.63 10.43c1.076.429 2.228.718 3.37.901 0 .87.086 1.764-.316 2.567l-1.578 3.156 1.79.894 1.552-3.105a.618.618 0 0 1 1.106 0l1.552 3.105 1.79-.894-1.578-3.156C13.915 13.094 14 12.2 14 11.33a16.5 16.5 0 0 0 3.359-.897c.025-.01-.73-1.862-.733-1.86-1.453.566-3.067.927-4.626.927"></path>
    </svg>
  );
};

Icon.Search = function Search(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m21 21-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0Z"
      />
    </svg>
  );
};

export default Icon;
